module.exports = __webpack_public_path__ + "img/bonus_banner_bg.eba79ba4.svg";